import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <>
      <Navbar />
    <section className="section-container">
      <div className="about-us-container">
        <section className="section legacy">
          <h2>Our Legacy</h2>
          <p>
            Established with a mission to deliver quality education to rural students, Shri Mulikadevi Mahavidyalaya, Nighoj, has been a beacon of knowledge and development in the Ahmednagar district. Over the years, the institution has grown into a reputed center for higher education, nurturing young minds with academic excellence, cultural values, and ethical responsibility.
          </p>
        </section>

        <section className="section vision-mission">
          <h2>Vision & Mission</h2>
          <h4>Vision</h4>
          <p>
            To empower students from rural backgrounds through quality education, fostering innovation, leadership, and holistic development.
          </p>
          <h4>Mission</h4>
          <ul>
            <li>To provide inclusive and accessible education to all sections of society.</li>
            <li>To promote critical thinking, creativity, and ethical values among students.</li>
            <li>To cultivate a spirit of social responsibility and lifelong learning.</li>
          </ul>
        </section>

        <section className="section principal-message">
          <h2>From Principal's Desk</h2>
          <p>
            "At Shri Mulikadevi Mahavidyalaya, we believe that education is the cornerstone of progress. Our commitment is to shape responsible citizens equipped with knowledge, compassion, and the courage to lead. I invite students to explore their potential, push boundaries, and become torchbearers of change."
          </p>
          <p className="principal-name">- Dr. S. K. Aher, Principal</p>
        </section>

        <section className="section achievements">
          <h2>Achievements</h2>
          <ul>
            <li>Accredited by NAAC with a remarkable grade.</li>
            <li>State-level awards in NSS and cultural programs.</li>
            <li>Consistent university ranking and merit scholarships.</li>
            <li>Active participation in Smart India Hackathon and other national competitions.</li>
            <li>1000+ students placed in reputed companies through placement drives.</li>
          </ul>
        </section>
      </div>
    </section>
      <Footer />
    </>
  );
};

export default AboutUs;
